import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivityTranscriptAndSummary as GetActivityTranscriptAndSummaryQuery,
    GetActivityTranscriptAndSummaryVariables as GetActivityTranscriptAndSummaryVariables,
    GetActivityTranscriptAndSummary_activity as Activity,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_TRANSCRIPT_AND_SUMMARY from '../queries/get-activity-transcript-and-summary.graphql';

export const useGetActivityTranscriptAndSummary = (
    activityId: string,
    skip: boolean
): {
    transcriptAndSummaryData: Activity | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetActivityTranscriptAndSummaryQuery,
        GetActivityTranscriptAndSummaryVariables
    >(GET_ACTIVITY_TRANSCRIPT_AND_SUMMARY, {
        variables: {
            activityId,
        },
        skip,
    });

    const transcriptAndSummaryData = data ? data.activity : null;

    return {
        transcriptAndSummaryData,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
